import { KEY } from './constants'

export const SET = `${KEY}/SET`
